import { VisitorSession } from 'sb-lib/types';
import { User } from './user';

export enum RecordingStatus {
  RECORDING = 'RECORDING',
  TRANSCODING = 'TRANSCODING',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
  REDACTED = 'REDACTED',
  PENDING_REDACTION = 'PENDING_REDACTION',
}

export interface VisitorSessionRecording {
  id: string;
  status: RecordingStatus;
  duration: number;
  userVideoUploadId: string;
  userVideoUrl: string;
  visitorVideoUploadId: string;
  visitorVideoUrl: string;
  userDisplayVideoUploadId?: string;
  userDisplayVideoUrl?: string;
  visitorDisplayVideoUploadId?: string;
  visitorDisplayVideoUrl?: string;
  rrwebJsonUrl: string;
  dateCreated: number;
  user: User;
  session: VisitorSession;
}

export interface VisitorContextualRecording {
  id: string;
  rrwebJsonUrl: string;
  status: RecordingStatus;
  visitor: { id: string };
  dateCreated: number;
  dateUpdated: number;
}
